<template>
<div>
    <el-container v-if="normalPage">
        <!-- 公共区域：顶部导航、左侧导航、帮助中心 -->
        <left_side :userType="userType"></left_side>
        <div class="left_side menu_mobile">
            <left_side_mobile :userType="userType"></left_side_mobile>
        </div>
        <el-main>
            <top_bar :userName="userName"></top_bar> 
            <div class="main_content">
                <el-alert
                    :title="title"
                    v-show="tipMsgShow"
                    :type="type"
                    effect="dark">
                </el-alert>
                <router-view />
            </div>
        </el-main>
    </el-container>
    <router-view v-else/>
</div>
</template>

<script>

import left_side from "./components/meun/left_side.vue";
import top_bar from "./components/meun/top_bar.vue";
import left_side_mobile from "./components/meun/left_side_mobile";

export default {
  name: "app",
  components: {
    left_side,
    top_bar,
    left_side_mobile,
    
  },
  data(){
      return{
        tipMsgShow:false,
        title:'保存成功',
        type:'success',
        normalPage:false,
        specialUrl:['login'],
        userName:'123123',
        userType:'',
      }
	},
    mounted(){
        let routes = this.getLastUrl();
        if(this.specialUrl.indexOf(routes) < 0){
            this.normalPage=true;
        }
        let that = this;
        this.$Bus.$on("tipSuccess", ({title}) => {
            that.title=title;
            that.type='success';
            that.tipMsgShow=true;
            that.timeToCloseTip();
        });
        this.$Bus.$on("tipError", ({title}) => {
            that.title=title;
            that.type='error';
            that.tipMsgShow=true;
            that.timeToCloseTip();
        });
        if(this.getLastUrl() !== 'login'){
            this.setUserInfo();
        }
    },
	methods:{
        setUserInfo(){
            let that = this;
            this.$API('/api/userInfo','get',{},function(response){
                if(response.code === 200){
                    that.userName = response.data.info.name;
                    that.userType = response.data.type;
                }
            });
        },
        toggleCollapse() {
            this.isCollapse = !this.isCollapse
        },
                
        timeToCloseTip(){
            let that = this;
            setTimeout(function(){
                that.tipMsgShow=false;
            },2000);
        },
    }
};
</script>

<style>
    .el-alert{
        width: 100%!important;
        z-index: 9!important;
        position: absolute!important;
        width: auto!important;
        left: 20px;
        top: 20px;
        right: 20px;

    }
</style>
